export const categories = [
  { id: 1, name: '电影', slug: 'movie', icon: 'ri-film-line', description: '最新院线大片、经典电影在线观看' },
  { id: 2, name: '电视剧', slug: 'tv', icon: 'ri-tv-line', description: '热门电视剧、网络剧全集在线' },
  { id: 3, name: '动漫', slug: 'anime', icon: 'ri-emotion-line', description: '日本动漫、国产动画在线观看' },
  { id: 4, name: '综艺', slug: 'variety', icon: 'ri-live-line', description: '热门综艺、真人秀节目在线' },
  { id: 5, name: '纪录片', slug: 'documentary', icon: 'ri-earth-line', description: 'BBC、Discovery纪录片在线' },
  { id: 6, name: '少儿', slug: 'kids', icon: 'ri-heart-line', description: '儿童动画、启蒙教育内容' },
];

export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  description: string;
  imageUrl: string;
  region: string;
  director: string;
  actors: string[];
  tags: string[];
  updateInfo: string;
  featured?: boolean;
  hotRank?: number;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: 'movie',
    year: 2026,
    rating: 9.2,
    description: '太阳急速老化，人类面临灭顶之灾。为了生存，人类在地球表面建造了巨大的行星发动机，开启了长达2500年的星际流浪之旅。第三部讲述人类在抵达新家园前的最后一段征程，面对未知宇宙的挑战。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20massive%20planet%20engine%20in%20space%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20futuristic%20technology%2C%20deep%20space%20background%20with%20stars%2C%20warm%20golden%20and%20orange%20tones%2C%20minimalist%20poster%20design%2C%20clean%20composition%2C%20Chinese%20sci-fi%20aesthetic&width=600&height=800&seq=movie-wandering-earth-3&orientation=portrait',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    tags: ['科幻', '冒险', '灾难', 'IMAX'],
    updateInfo: 'HD1080P',
    featured: true,
    hotRank: 1,
  },
  {
    id: 2,
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    category: 'tv',
    year: 2024,
    rating: 9.4,
    description: '九十年代的上海，人人争上游。阿宝也变成了宝总，成功过，失败过，在沪上弄潮儿女中留下一段传奇。有过金碧辉煌，有过细水长流，男男女女，涨涨跌跌，道尽一个时代的情义与至真。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20warm%20golden%20lighting%2C%20vintage%20cityscape%2C%20nostalgic%20atmosphere%2C%20art%20deco%20elements%2C%20luxurious%20gold%20and%20amber%20tones%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-blossoms-shanghai&orientation=portrait',
    region: '中国大陆',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    tags: ['剧情', '年代', '商战', '爱情'],
    updateInfo: '更新至30集',
    featured: true,
    hotRank: 2,
  },
  {
    id: 3,
    title: '鬼灭之刃 无限城篇',
    titleEn: 'Demon Slayer: Infinity Castle',
    category: 'anime',
    year: 2026,
    rating: 9.5,
    description: '炭治郎一行人被传送到无限城，无惨的最终决战即将拉开帷幕。面对鬼舞辻无惨及其上弦之鬼，鬼杀队将付出怎样的代价才能终结这千年之战？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20with%20swordsman%20in%20traditional%20Japanese%20setting%2C%20dynamic%20action%20pose%2C%20flame%20effects%2C%20dark%20and%20warm%20contrast%20lighting%2C%20epic%20battle%20scene%20vibe%2C%20clean%20poster%20design%2C%20dramatic%20composition&width=600&height=800&seq=movie-demon-slayer&orientation=portrait',
    region: '日本',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    tags: ['热血', '战斗', '奇幻', '剧场版'],
    updateInfo: 'HD1080P',
    featured: true,
    hotRank: 3,
  },
  {
    id: 4,
    title: '漫长的季节',
    titleEn: 'The Long Season',
    category: 'tv',
    year: 2023,
    rating: 9.5,
    description: '小城桦林，出租车司机王响做梦也没想到，他还有机会遇到一个他这辈子最想遇到，又最怕遇到的人。二十年前的一桩悬案，打破了这个东北小城的平静。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20Chinese%20crime%20drama%20poster%20set%20in%20northeast%20China%2C%20autumn%20tones%2C%20misty%20industrial%20town%2C%20melancholic%20atmosphere%2C%20warm%20amber%20and%20rust%20colors%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-long-season&orientation=portrait',
    region: '中国大陆',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    tags: ['悬疑', '犯罪', '剧情', '家庭'],
    updateInfo: '全12集',
    hotRank: 4,
  },
  {
    id: 5,
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: 'movie',
    year: 2023,
    rating: 8.8,
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默主导制造出世界上第一颗原子弹的故事。在二战期间，奥本海默领导了曼哈顿计划，成功研制出原子弹，但随之而来的道德困境和内心挣扎也让他陷入了深深的痛苦之中。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20biographical%20drama%20movie%20poster%20with%20nuclear%20explosion%20silhouette%2C%20black%20and%20white%20with%20warm%20orange%20fire%20accents%2C%20dramatic%20portrait%2C%20minimalist%20poster%20design%2C%20cinematic%20lighting%2C%20clean%20composition&width=600&height=800&seq=movie-oppenheimer&orientation=portrait',
    region: '美国',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    tags: ['传记', '历史', '剧情', 'IMAX'],
    updateInfo: 'HD1080P',
    hotRank: 5,
  },
  {
    id: 6,
    title: '庆余年 第二季',
    titleEn: 'Joy of Life Season 2',
    category: 'tv',
    year: 2024,
    rating: 9.0,
    description: '范闲从北齐归来后，发现自己在京城的处境更加险恶。面对二皇子的步步紧逼和朝堂之上的尔虞我诈，范闲将如何运用自己的智慧和力量，在这个危机四伏的世界中开辟出一条属于自己的道路？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20warrior%20in%20flowing%20robes%2C%20misty%20mountain%20landscape%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20elegant%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-joy-of-life&orientation=portrait',
    region: '中国大陆',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    tags: ['古装', '权谋', '奇幻', '喜剧'],
    updateInfo: '更新至36集',
    hotRank: 6,
  },
  {
    id: 7,
    title: '间谍过家家 代号：白',
    titleEn: 'SPY x FAMILY CODE: White',
    category: 'anime',
    year: 2024,
    rating: 9.1,
    description: '为了执行任务"枭"，间谍黄昏组建了一个临时家庭。妻子约尔是杀手，女儿阿尼亚是会读心的超能力者。这一家三口在日常的温馨与刺激的任务之间，上演了一幕幕令人捧腹又感动的故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20family%20comedy%20poster%20with%20spy%20theme%2C%20warm%20pastel%20colors%2C%20playful%20composition%2C%20three%20characters%20with%20distinct%20personalities%2C%20clean%20minimalist%20poster%20design%2C%20soft%20lighting&width=600&height=800&seq=movie-spy-family&orientation=portrait',
    region: '日本',
    director: '片桐崇',
    actors: ['江口拓也', '种崎敦美', '早见沙织', '吉野裕行'],
    tags: ['喜剧', '动作', '家庭', '日常'],
    updateInfo: 'HD1080P',
    hotRank: 7,
  },
  {
    id: 8,
    title: '飞驰人生2',
    titleEn: 'Pegasus 2',
    category: 'movie',
    year: 2024,
    rating: 8.6,
    description: '昔日冠军车手张驰沦为落魄驾校教练，意外获得重返车坛的机会。面对新老对手的挑战和笑料百出的各种状况，张驰能否再次驰骋赛场，实现自己的人生逆袭？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20on%20desert%20track%2C%20warm%20golden%20sunset%20lighting%2C%20dynamic%20motion%20feel%2C%20dusty%20atmosphere%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-pegasus-2&orientation=portrait',
    region: '中国大陆',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜'],
    tags: ['喜剧', '赛车', '运动', '励志'],
    updateInfo: 'HD1080P',
    hotRank: 8,
  },
  {
    id: 9,
    title: '三体',
    titleEn: 'Three-Body',
    category: 'tv',
    year: 2023,
    rating: 8.7,
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入"科学边界"组织协助调查。在调查过程中，汪淼接触到一个名为"三体"的神秘VR游戏，由此揭开了人类文明与三体文明之间长达数百年的对抗序幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20cosmic%20mystery%20theme%2C%20three%20suns%20in%20alien%20sky%2C%20deep%20space%20background%2C%20futuristic%20technology%20elements%2C%20warm%20amber%20and%20cool%20contrast%2C%20minimalist%20poster%20design&width=600&height=800&seq=movie-three-body&orientation=portrait',
    region: '中国大陆',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    tags: ['科幻', '悬疑', '剧情', '名著改编'],
    updateInfo: '全30集',
    hotRank: 9,
  },
  {
    id: 10,
    title: '进击的巨人 最终季',
    titleEn: 'Attack on Titan Final Season',
    category: 'anime',
    year: 2023,
    rating: 9.3,
    description: '艾伦·耶格尔发动"地鸣"，无数超大型巨人踏平世界。曾经的伙伴们为了阻止艾伦，组成了最后的联军。在自由与生命、毁灭与拯救之间，究竟谁能笑到最后？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20anime%20poster%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20battle%20scene%2C%20dark%20sky%20with%20warm%20sunset%20lighting%2C%20apocalyptic%20atmosphere%2C%20clean%20poster%20design%2C%20powerful%20composition&width=600&height=800&seq=movie-attack-on-titan&orientation=portrait',
    region: '日本',
    director: '林祐一郎',
    actors: ['梶裕贵', '石川由依', '井上麻里奈', '下野纮'],
    tags: ['战斗', '黑暗', '剧情', '史诗'],
    updateInfo: '全28集',
    hotRank: 10,
  },
  {
    id: 11,
    title: '热辣滚烫',
    titleEn: 'YOLO',
    category: 'movie',
    year: 2024,
    rating: 8.4,
    description: '乐莹是一个善良但总是受欺负的女孩。在经历了一系列生活的打击后，她决定通过拳击改变自己。从被人看不起的小人物到站在擂台上的拳击手，乐莹用自己的方式证明：人生只有一次，要为自己而活。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sports%20drama%20movie%20poster%20with%20female%20boxer%20in%20ring%2C%20warm%20motivational%20lighting%2C%20sweat%20and%20determination%2C%20golden%20hour%20glow%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-yolo&orientation=portrait',
    region: '中国大陆',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    tags: ['喜剧', '运动', '励志', '剧情'],
    updateInfo: 'HD1080P',
  },
  {
    id: 12,
    title: '葬送的芙莉莲',
    titleEn: 'Frieren: Beyond Journey\'s End',
    category: 'anime',
    year: 2023,
    rating: 9.4,
    description: '勇者一行人历经十年冒险打败魔王后，精灵魔法使芙莉莲踏上了了解人类的旅程。身为长寿种族的她，在同伴相继离世后才逐渐意识到生命的重量和情感的珍贵。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20poster%20with%20elf%20mage%20in%20peaceful%20journey%2C%20soft%20pastel%20greens%20and%20warm%20golden%20light%2C%20nostalgic%20atmosphere%2C%20beautiful%20landscape%20background%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-frieren&orientation=portrait',
    region: '日本',
    director: '斋藤圭一郎',
    actors: ['种崎敦美', '冈本信彦', '东地宏树', '上田耀司'],
    tags: ['奇幻', '冒险', '治愈', '剧情'],
    updateInfo: '全28集',
  },
  {
    id: 13,
    title: '王牌对王牌 第八季',
    titleEn: 'Trump Card Season 8',
    category: 'variety',
    year: 2024,
    rating: 8.1,
    description: '经典综艺节目《王牌对王牌》第八季重磅回归！沈腾、贾玲、华晨宇、关晓彤组成的王牌家族继续带来爆笑游戏和精彩表演，每期邀请重量级嘉宾同台PK，欢乐不停歇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20game%20show%20theme%2C%20warm%20golden%20stage%20lighting%2C%20festive%20atmosphere%2C%20celebrities%20in%20fun%20poses%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-trump-card&orientation=portrait',
    region: '中国大陆',
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    tags: ['综艺', '搞笑', '游戏', '真人秀'],
    updateInfo: '更新至第8期',
  },
  {
    id: 14,
    title: '地球脉动 第三季',
    titleEn: 'Planet Earth III',
    category: 'documentary',
    year: 2024,
    rating: 9.7,
    description: 'BBC史诗级自然纪录片第三季，从海洋深处到雪山之巅，从热带雨林到极地冰原，用最先进的拍摄技术记录地球上最震撼的自然奇观和动物生存故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20warm%20golden%20sunlight%20through%20forest%2C%20diverse%20ecosystems%2C%20breathtaking%20natural%20beauty%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-planet-earth&orientation=portrait',
    region: '英国',
    director: 'BBC自然历史部',
    actors: ['大卫·爱登堡'],
    tags: ['自然', '纪录片', 'BBC', '4K'],
    updateInfo: '全8集',
  },
  {
    id: 15,
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    category: 'movie',
    year: 2025,
    rating: 8.9,
    description: '殷商末年，纣王无道。姬发觉醒后率军东征，与殷商大军在牧野展开决战。姜子牙率领的阐教仙人与申公豹率领的截教仙人也加入了这场决定天下归属的大战，封神之战正式拉开帷幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20magical%20creatures%2C%20dramatic%20battle%20scene%2C%20warm%20fire%20and%20golden%20lighting%2C%20grand%20scale%2C%20minimalist%20poster%20design&width=600&height=800&seq=movie-creation-gods&orientation=portrait',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    tags: ['奇幻', '神话', '战争', '史诗'],
    updateInfo: 'HD1080P',
  },
  {
    id: 16,
    title: '超级飞侠 第16季',
    titleEn: 'Super Wings Season 16',
    category: 'kids',
    year: 2025,
    rating: 8.5,
    description: '乐迪和他的超级飞侠伙伴们继续环游世界，帮助小朋友们解决各种问题。在这一季中，超级飞侠们将去到更多新奇的地方，认识更多有趣的朋友。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20children%20animation%20poster%20with%20colorful%20airplanes%20and%20friendly%20characters%2C%20bright%20warm%20colors%2C%20playful%20world%20travel%20theme%2C%20happy%20atmosphere%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-super-wings&orientation=portrait',
    region: '中国大陆',
    director: '冯操',
    actors: ['张子焜', '徐可馨', '刘子甄'],
    tags: ['少儿', '动画', '冒险', '教育'],
    updateInfo: '更新至20集',
  },
  {
    id: 17,
    title: '狂飙',
    titleEn: 'The Knockout',
    category: 'tv',
    year: 2023,
    rating: 9.3,
    description: '京海市，一线刑警安欣在与黑恶势力的斗争中，不断遭到保护伞的打击。在全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，一举铲除了盘踞京海多年的强盛集团。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20drama%20poster%2C%20dark%20and%20gritty%20atmosphere%2C%20police%20vs%20gangster%20theme%2C%20urban%20night%20scene%2C%20warm%20street%20light%20contrast%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-the-knockout&orientation=portrait',
    region: '中国大陆',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    tags: ['犯罪', '剧情', '扫黑', '悬疑'],
    updateInfo: '全39集',
    hotRank: 3,
  },
  {
    id: 18,
    title: '铃芽之旅',
    titleEn: 'Suzume',
    category: 'anime',
    year: 2023,
    rating: 8.5,
    description: '生活在九州乡间的17岁少女铃芽，遇到了一名正在寻找"门"的青年。铃芽追随青年进入了一片废墟，发现了一扇古老的门。不久之后，日本各地开始出现更多的门，铃芽必须踏上旅途，将这些门一一关闭。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20fantasy%20movie%20poster%20with%20girl%20and%20mysterious%20doors%2C%20surreal%20watercolor%20art%20style%2C%20soft%20warm%20sunset%20sky%2C%20Japanese%20landscape%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-suzume&orientation=portrait',
    region: '日本',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里', '染谷将太'],
    tags: ['奇幻', '冒险', '爱情', '治愈'],
    updateInfo: 'HD1080P',
  },
  {
    id: 19,
    title: '奔跑吧 第十二季',
    titleEn: 'Keep Running Season 12',
    category: 'variety',
    year: 2024,
    rating: 7.8,
    description: '国民综艺《奔跑吧》第十二季热血回归！李晨、郑恺、沙溢、白鹿、周深等固定成员再次集结，带来全新的游戏挑战和爆笑互动，每期更有超强飞行嘉宾助阵。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%20with%20energetic%20team%20running%2C%20bright%20sunny%20day%2C%20warm%20golden%20lighting%2C%20dynamic%20action%20poses%2C%20minimalist%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-keep-running&orientation=portrait',
    region: '中国大陆',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    tags: ['综艺', '真人秀', '户外', '搞笑'],
    updateInfo: '更新至第6期',
  },
  {
    id: 20,
    title: '孤注一掷',
    titleEn: 'No More Bets',
    category: 'movie',
    year: 2023,
    rating: 8.3,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了逃离，两人准备利用赌徒阿天和女友小雨，从他们身上套现完成业绩。一场充满智慧与勇气的反诈斗争就此展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20movie%20poster%20about%20online%20scam%2C%20dark%20neon%20lighting%2C%20Southeast%20Asian%20setting%2C%20technology%20and%20danger%20theme%2C%20warm%20red%20and%20gold%20contrast%2C%20minimalist%20poster%20design&width=600&height=800&seq=movie-no-more-bets&orientation=portrait',
    region: '中国大陆',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    tags: ['犯罪', '剧情', '悬疑', '反诈'],
    updateInfo: 'HD1080P',
  },
];